import qs from 'qs';
import axios from 'axios';

// Projects API

function loadProjects(filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  return axios.get(`/projects${query}`);
}

function loadProject(projectId) {
  return axios.get(`/projects/${projectId}`);
}

function createProject(payload, filter) {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  return axios.post(`/projects${query}`, payload);
}

function editProject(projectId, payload) {
  return axios.put(`/projects/${projectId}`, payload);
}

// Crawlers API

function loadCrawlerSettings(projectId) {
  return axios.get(`/projects/${projectId}/crawler`);
}

function editCrawlerSettings(projectId, payload) {
  return axios.put(`/projects/${projectId}/crawler`, payload);
}

function createCrawlerPreview(projectId, payload) {
  return axios.post(`/projects/${projectId}/crawler-preview`, payload);
}

export {
  loadProjects,
  loadProject,
  loadCrawlerSettings,
  createProject,
  editProject,
  editCrawlerSettings,
  createCrawlerPreview,
};
